import { Flex, Image, Link, Text, Textarea } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import React from 'react';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { Icon } from '@lon/shared/components';
import { useQueryParams } from '@lon/shared/hooks';

const ErrorPage = () => {
  const { t } = useTranslation();
  const [params] = useQueryParams();
  const payloadFromCookie = Cookies.get('sso-user-request');

  return (
    <Flex
      direction="column"
      as="main"
      alignItems="center"
      justifyContent="center"
      position="relative"
      w="full"
      h="full"
      gap={6}
      px={6}
      backgroundImage="login/assets/main-background.webp"
      backgroundRepeat="no-repeat"
      backgroundSize={{ md: 'cover', base: 'fill' }}
    >
      <Image
        filter="brightness(0) invert(1)"
        src="login/assets/acceleratelearning-login.svg"
        alt="Accelerate Learning"
        height="44px"
        zIndex={1}
        mb="12px"
      />
      <Flex
        maxH={430}
        maxW={600}
        w="100%"
        height="100%"
        zIndex="1"
        direction="column"
        borderRadius="20px"
        background="linear-gradient(180deg, #FFF 64.65%, rgba(255, 255, 255, 0.72) 100%)"
      >
        <Flex
          py="23"
          px="32"
          borderTopLeftRadius="20px"
          borderTopRightRadius="20px"
          background="linear-gradient(285deg, #BD1200 11.55%, #D93828 91.56%)"
          justifyContent="center"
        >
          <Text color="white" textAlign="center" variant="rm">
            {t(`publicErrors.title`)}
          </Text>
        </Flex>
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          flexGrow="1"
          color="#CC1300"
          gap={4}
          paddingX={6}
        >
          <Icon size="xxl" name="close-circle-outlined" />
          <Flex alignItems="center" gap={2}>
            <Text variant="h5">
              {t(`publicErrors.titles.${params.get('code')}`, 'Unknown error.')}
            </Text>
          </Flex>

          <Text textAlign="center" variant="n3">
            <Trans
              i18nKey={t(
                'publicErrors.description',
                'An unknown error has occurred. <br> Please try again later.'
              )}
            />
          </Text>

          {payloadFromCookie && (
            <Flex gap={2} width="100%" flexDirection="column">
              <Text textAlign="center" variant="n3">
                {t('publicErrors.copyManually')}
              </Text>
              <Textarea
                resize="none"
                defaultValue={payloadFromCookie}
                readOnly
              />
            </Flex>
          )}
        </Flex>
      </Flex>
      <Link
        href="/login"
        isExternal
        textDecoration="underline"
        fontWeight={500}
        aria-label="Customer Support"
      >
        <Text variant="su4" color="white" _hover={{ textDecoration: 'none' }}>
          {t(`publicErrors.customerSupport`)}
        </Text>
      </Link>
    </Flex>
  );
};

export default ErrorPage;
